<template>
    <div>
        <!-- Header including Tab titles-->
        <div v-if="enabledHeader" ref="scrollable" :class="'lg:justify-' + align" class="custom-scrollbar flex relative overflow-x-auto snap-x pb-1">
            <div :class="align === 'center' ? 'mx-auto' : ''" class="w-auto inline-flex gap-2 md:gap-6 lg:gap-8">
                <div
                    v-for="(item, key) in data"
                    :key="item.id"
                    @click="[$emit('update:activeTab', item, key), (activeTabIndex = key)]"
                    class="p-1 md:p-4 relative h-full cursor-pointer snap-center"
                >
                    <slot name="header" :data="item"></slot>
                    <div v-if="activeTabIndex === key" class="tab-indicator w-auto absolute bottom-0 left-0 right-0 h-0.5 z-10" />
                </div>
            </div>
            <div ref="scrollbar" class="w-full absolute bottom-1 left-0 right-0 bg-gray-300 h-0.5 z-0" />
        </div>
        <!-- Content of individual Tabs -->
        <div class="flex justify-end h-10 sm:hidden" v-if="enabledHeader">
            <div class="p-1 md:p-4 absolute left-5 h-auto cursor-pointer snap-center">
                <svg
                    @click="activeTabIndex = activeTabIndex - 1"
                    xmlns="http://www.w3.org/2000/svg"
                    :class="['h-6 w-6', activeTabIndex > 0 ? 'black' : 'text-[#80808047] pointer-events-none']"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </div>

            <div class="p-1 md:p-4 absolute right-5 h-auto cursor-pointer snap-center">
                <svg
                    @click="activeTabIndex = activeTabIndex + 1"
                    xmlns="http://www.w3.org/2000/svg"
                    :class="['h-6 w-6', activeTabIndex < data.length - 1 ? 'black' : 'text-[#80808047] pointer-events-none']"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </div>
        </div>
        <div class="mt-4">
            <div v-for="(item, key) in data" :key="item.id">
                <slot v-if="activeTabIndex === key" name="item" :key="key" :data="item"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        data: Array,
        activeTab: [String, Number],
        firstOnLoad: Boolean,
        activeColor: String,
        overlay: Boolean,
        align: String,
        enabledHeader: {
            type: Boolean,
            default: true
        }
    },

    emits: ['update:activeTab'],

    data: () => ({
        activeTabIndex: null
    }),

    mounted() {
        if (this.firstOnLoad) {
            this.$emit('update:activeTab', _.first(this.data));
            this.activeTabIndex = this.activeTab ?? 0;
        } else if (this.activeTab) {
            this.activeTabIndex = this.data.indexOf(this.activeTab);
        }

        this.$refs.scrollbar.style.width = this.$refs.scrollable.scrollWidth + 'px';
    },

    methods: {
        activateCategory(slug) {
            if (this.data) {
                for (let index = 0; index < this.data.length; index++) {
                    if (this.data[index].slug?.name == slug) {
                        this.activeTabIndex = index;

                        this.$emit('update:activeTab', this.data[index]);
                        break;
                    }
                }
            }
        }
    },

    watch: {
        activeColor: function () {
            return this.activeColor;
        },

        activeTab: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.activeTabIndex = newVal;
            }
        }
    }
};
</script>

<style scoped>
.tab-indicator {
    background-color: v-bind(activeColor);
}
</style>
